export const removePunctuation = (value: string): string => value.normalize('NFD').replaceAll(/[\u0300-\u036F]/g, '');
